import { styled } from '@mui/material';

import { Button } from '@/shared/ui/lib/Button';

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  whiteSpace: 'nowrap',
  color: theme.palette.actions.go,

  '&:active': {
    color: theme.palette.actions.go,
    opacity: '0.8',
  },
}));
